export default {
  login: "Silahkan masuk untuk melanjutkan...",
  password_rule: "* Kata sandi peka huruf besar dan kecil dan panjangnya harus 6 hingga 10 karakter.",
  nickname_rule:
    "* Anda bisa mengatur nama panggilan untuk tampilan dan log masuk (6 hingga 15 huruf atau angka). Harap diperhatikan, Anda hanya bisa mengatur nama panggilan ini satu kali. Anda tidak dapat memodifikasi atau membatalkannya setelah nama panggilan itu diatur.",
  change_password_succeed: "Ubah Kata Sandi Berhasil",
  add_secondary_succeed: "Tetapkan Nama Panggilan Berhasil",
  succeed: "Anda berhasil menyelesaikan tindakan!",
  failed: "Anda gagal menyelesaikan tindakan!",
  no_information_available: "Tidak Ada Informasi Yang Tersedia",
  select_display_language: "Pilih bahasa default yang Anda inginkan.",
  select_odds_type: "Pilih tampilan jenis peluang standar yang Anda inginkan.",
  select_page_type: "Pilih jenis halaman pilihan Anda sebagai default untuk ditampilkan di halaman hari ini dan halaman awal..",
  select_show_score_map: "Aktifkan sistem untuk secara otomatis menampilkan peta skor saat memasang taruhan..",
  select_default_event_sorting: "Pilih tampilan penyortiran acara default yang Anda inginkan..",
  select_market_type: "Pilih pasar pilihan Anda..",
  select_page_size: "Pilih ukuran halaman pilihan Anda..",
  change_sports_menu_order: "Seret olahraga utuk mengubah urutan menu Olahraga sesuai keinginan.",
  view_outstanding_bets_in_bet_list: "Taruhan yang masih berjalan mungkin perlu waktu untuk diproses. Buka Daftar Taruhan untuk melihat taruhan masih berjalan terbaru Anda..",
  time_display_in_gmt_plus_8: "The time above is displayed in GMT+8.",
  select_default_stake: "Aktifkan Sistem Untuk Secara Otomatis Memasukkan Taruhan Khusus Anda Dan Taruhan Taruhan Terakhir.",
  bet_empty: "Slip taruhan Anda kosong. Klik odd pada tabel untuk membuat pilihan taruhan..",
  no_event: "Tidak ada acara atau game yang tersedia saat ini. Harap kunjungi acara olahraga atau game lain dan kembali nanti",
  no_bets: "Tidak Ada Taruhan Berjalan",
  no_waiting: "Tidak Ada Taruhan Menunggu",
  no_void: "Tidak Ada Taruhan Yang Gugur",
  confirmation: "Apakah Anda mengonfirmasi untuk memasang taruhan ini?",
  olderversion: "Versi yang lebih lama terdeteksi, klik OK untuk memperbarui atau tekan Ctrl-F5",
  gmt8: "Mohon diperhatikan bahwa waktu yang ditampilkan berdasarkan waktu GMT+8",
  confirm_bet: "Konfirmasikan Taruhan?",
  match_not_started: "Pertandingan Belum Dimulai",
  odds_changed: "Odd telah berubah dari",
  to: "to",

  days: "Hari",
  hours: "Jam",
  mins: "Menit",
  secs: "Detik",

  button_skip: "Lewati tur",
  button_previous: "Sebelumnya",
  button_next: "Berikutnya",
  button_stop: "Selesai",
  button_continue: "Lanjutkan",
};
